import lodash from "lodash";
import i18n from "../../../../../../i18n";
//import { Button, Input, Form } from "ant-design-vue";
import { createFieldDate, createFieldInput } from "../../../../../../components/input/template-builder/template-builder.logic";
import { conditionFormChecker, putField } from "../../../../../../utils/form";
import { callVesselByCode } from "../../../vessel/vessel.section";
import { setIsLoading as setIsLoadingApp } from "../../../../../../app.logic";
import { defineAsyncComponent } from "vue";

export const AttachmentFullVessel = defineAsyncComponent(() => import("./attachment-vessel/AttachmentFullVessel"));
const CardBorder = defineAsyncComponent(() => import("../../../../../../components/card/CardBorder"));


export const createField = ({ props, data }) => {
    const { viewOnly, itemsKey, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    const prefix = itemsKey ? `${itemsKey}.` : "";
    const isShowOriginalVesselAttachment = "refVesselRequest" === itemsKey ? true : false
    return putField({
        data,
        fields: [
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}code`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.vessel.code"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.code,
                            "onUpdate:value": (value) => {
                                //const oldValue = model.code;
                                if (["replaceBoat"].includes(modelRef.refChangeLicenseObjective?.key)) {
                                    model.code = value;
                                }
                                //
                            },
                            disabled: viewOnly,
                            enterButton: true,
                            onSearch: () => {
                                setIsLoadingApp(true);
                                callVesselByCode({ shipCode: model.code }).then((resp) => {
                                    setIsLoadingApp(false);
                                    //616500412
                                    model.vesselOwnerRequests = [];
                                    model.code = resp.shipCode;
                                    model.name = resp.thaName;
                                    model.tgross = resp.tgross;
                                    model.tnange = resp.tnet;
                                    model.vesselType = resp.shipType;
                                    model.useType = resp.useTypeName;
                                    model.licenseIssueDate = resp.permitLocalDate;
                                    model.licenseExpireDate = resp.perExpLocalDate;
                                    model.licenseNumber = resp.certNo;
                                    model.registrationDate = resp.regLocalDate;
                                    model.lbp = resp.shipLengthLong;
                                    model.loa = resp.shipLength;
                                    model.deep = resp.depth;
                                    model.breadth = resp.width;
                                    resp?.ownerHistoryAllBean?.forEach((a, index) => {
                                        model.vesselOwnerRequests[index] = {
                                            addr: a.address,
                                            pid: a.idCard,
                                            firstName: a.name,
                                            ownershipDate: a.dateTransfer,
                                        };
                                    });
                                    model.vesselOwnerTemp = resp?.ownerHistoryAllBean;
                                });
                            },
                            allowClear: false,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}name`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.vessel.name"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.name,
                            "onUpdate:value": (value) => (model.name = value),
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}tgross`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.vessel.vesselSize"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.tgross,
                            "onUpdate:value": (value) => (model.tgross = value),
                            disabled: true,
                            addonAfter: i18n.global.t("model.vessel.tgross"),
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}tnange`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.vessel.vesselSize"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.tnange,
                            "onUpdate:value": (value) => (model.tnange = value),
                            disabled: true,
                            addonAfter: i18n.global.t("model.vessel.tnange"),
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}vesselType`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.vessel.vesselType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.vesselType,
                            "onUpdate:value": (value) => (model.vesselType = value),
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}useType`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.vessel.useType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.useType,
                            "onUpdate:value": (value) => (model.useType = value),
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}licenseIssueDate`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.vessel.licenseIssueDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.licenseIssueDate,
                            "onUpdate:value": (value) => (model.licenseIssueDate = value),
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}licenseExpireDate`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.vessel.licenseExpireDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.licenseExpireDate,
                            "onUpdate:value": (value) => (model.licenseExpireDate = value),
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}registrationDate`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.vessel.registrationDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.registrationDate,
                            "onUpdate:value": (value) => (model.registrationDate = value),
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),

            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lbp`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.vessel.lbp"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.lbp,
                            "onUpdate:value": (value) => (model.lbp = value),
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}loa`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.vessel.loa"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.loa,
                            "onUpdate:value": (value) => (model.loa = value),
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}deep`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.vessel.deep"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.deep,
                            "onUpdate:value": (value) => (model.deep = value),
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}breadth`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.vessel.breadth"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.breadth,
                            "onUpdate:value": (value) => (model.breadth = value),
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}licenseNumber`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.vessel.licenseNumber"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.licenseNumber,
                            "onUpdate:value": (value) => (model.licenseNumber = value),
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            {
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}attachmentVesselIdentities`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                // label: () => i18n.global.t("model.user.refAttachIdCard"),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            dataKey: `${prefix}attachmentVesselIdentities.0`,
                            labelExampleImage: "",
                            canCreate: !viewOnly,
                            canDelete: !viewOnly,
                            attachmentGroup: "VesselIdentity",
                            previewPicture: data.previewVesselRequestAttachment?.find(file => file.group === "VesselIdentity"),
                            isShowOriginalVesselAttachment: isShowOriginalVesselAttachment
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "attachmentVesselIdentities" } })
                    );
                    return <CardBorder bodyStyle={{ padding: '10px 24px' }} headerSize="small" title={i18n.global.t("model.vessel.imageVesselIdentity")} class="mt-3 border-radius-1"><AttachmentFullVessel {...componentProp}></AttachmentFullVessel></CardBorder>;
                },
            },
            {
                visible: (({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } })),
                key: `${prefix}attachmentPositionVesselIdentities`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                // label: () => i18n.global.t("model.user.refAttachIdCard"),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            dataKey: `${prefix}attachmentPositionVesselIdentities.0`,
                            labelExampleImage: "",
                            canCreate: !viewOnly,
                            canDelete: !viewOnly,
                            attachmentGroup: "PositionVesselIdentity",
                            previewPicture: data.previewVesselRequestAttachment?.find(file => file.group === "PositionVesselIdentity"),
                            isShowOriginalVesselAttachment: isShowOriginalVesselAttachment
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "attachmentPositionVesselIdentities" } })
                    );
                    return <CardBorder bodyStyle={{ padding: '10px 24px' }} headerSize="small" title={i18n.global.t("model.vessel.imagePositionVesselIdentity")} class="border-radius-1"><AttachmentFullVessel {...componentProp}></AttachmentFullVessel></CardBorder>;
                },
            },
            {
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}attachmentHeadVessels`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                // label: () => i18n.global.t("model.user.refAttachIdCard"),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            dataKey: `${prefix}attachmentHeadVessels.0`,
                            labelExampleImage: "",
                            canCreate: !viewOnly,
                            canDelete: !viewOnly,
                            attachmentGroup: "HeadVessel",
                            previewPicture: data.previewVesselRequestAttachment?.find(file => file.group === "HeadVessel"),
                            isShowOriginalVesselAttachment: isShowOriginalVesselAttachment
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "attachmentHeadVessels" } })
                    );
                    return <CardBorder bodyStyle={{ padding: '10px 24px' }} headerSize="small" title={i18n.global.t("model.vessel.imageHeadVessel")} class="border-radius-1"><AttachmentFullVessel {...componentProp}></AttachmentFullVessel></CardBorder>;
                },
            },
            {
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}attachmentFullVessels`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                // label: () => i18n.global.t("model.user.refAttachIdCard"),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            dataKey: `${prefix}attachmentFullVessels.0`,
                            labelExampleImage: "",
                            labelTop: "",
                            canCreate: !viewOnly,
                            canDelete: !viewOnly,
                            attachmentGroup: "FullVessel",
                            previewPicture: data.previewVesselRequestAttachment?.find(file => file.group === "FullVessel"),
                            isShowOriginalVesselAttachment: isShowOriginalVesselAttachment
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "attachmentFullVessels" } })
                    );
                    return <CardBorder bodyStyle={{ padding: '10px 24px' }} headerSize="small" title={i18n.global.t("model.vessel.imageFullVessel")} class="border-radius-1"><AttachmentFullVessel {...componentProp}></AttachmentFullVessel></CardBorder>;
                },
            },
        ],
    });
};
